import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer, useRef, useState } from "react";
import { Button, FormGroup, Modal } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { updateAllProductsPrice } from "../store/api/GetAllProduct";
import NewNumberInput from "../../Components/NewNumberInput";
import { Check2Square } from "react-bootstrap-icons";
import { searchHolders, getAllProductTypesNew } from "../store/api/GetAllProduct";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useDispatch, useSelector } from "react-redux";
import { faListOl, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ModalUpdateProductsPrice(props) {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const [pending, setPending] = useState(false);
    const [typeList, setTypeList] = useState();
    const [holderList, setHolderList] = useState();
    const { show } = popData;
    const productsPriceInfo = useRef({ PriceName: "SalePrice", IsPercent: true });
    const { settings} = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings
        }
    });
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings ?? "") ? Number(settings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    function close() {
        setPopData({ show: false });
    }
    function updatePrice() {
        if (pending) {
            return false;
        }

        if (!productsPriceInfo.current.Value) {
            setErrorDialog(dispatch, "مبلغ/ درصد وارد نشده است.");
            return;
        }

        const onUpdate = (res) => {
            setPending(!(res.Data || res.Error));

            if (res.Data) {
                setErrorDialog(dispatch, res.Data, "ویرایش قیمت ها");
                // productsPriceInfo.current = { PriceName: "SalePrice", IsPercent: true };

            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ویرایش قیمت ها")
            }
        }
        setPending(true);
        updateAllProductsPrice(productsPriceInfo.current, onUpdate);
    }
    useEffect(() => {
        if(show)
        {
        dispatch(getSystemSettings(settingNames));
        getAllProductTypesNew(setTypeList);
        searchHolders("","", setHolderList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faListOl} size="lg" />&nbsp;
                    بروزرسانی قیمت کالا ها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "0px" }}>
                <FormGroup>
                    {holderList === "PENDING" &&
                        <div className="form-control">
                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                        </div>
                    }
                    {holderList && Array.isArray(holderList) &&
                        <select name="HolderID" className="form-control" onChange={e => productsPriceInfo.current.HolderID = e.target.value}
                        >
                            <option value="">مارک کالا را انتخاب کنید</option>
                            {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                        </select>
                    }
                </FormGroup>
                {pgType !== 1 &&
                    <FormGroup>
                        {typeList === "PENDING" &&
                            <div className="form-control">
                                <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                            </div>
                        }
                        {typeList && Array.isArray(typeList) &&
                            <select className="form-control" onChange={e => productsPriceInfo.current.TypeID = e.target.value}
                            >
                                <option value="">نوع کالا را انتخاب کنید</option>
                                {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                            </select>
                        }
                    </FormGroup>
                }
                <FormGroup>
                    <NewNumberInput onChange={e => productsPriceInfo.current.Value = e.target.value} placeholder="مبلغ/درصد" />
                </FormGroup>
                <FormGroup>
                    <select className="form-control" onChange={e => productsPriceInfo.current.IsPercent = e.target.value}>
                        <option value={true}>درصد</option>
                        <option value={false}>مبلغ ثابت</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <select className="form-control" onChange={e => productsPriceInfo.current.PriceName = e.target.value}>
                        <option value="SalePrice">قیمت فروش</option>
                        <option value="SalePrice3">قیمت فروش سوم</option>
                        <option value="GauranteeSalePrice">قیمت فروش گارانتی</option>
                    </select>
                </FormGroup>
                <Button className="group-Btn mt-2" variant="info" onClick={updatePrice} disabled={pending}><Check2Square size={18} />&nbsp;انجام بروزرسانی</Button>
            </Modal.Body>
        </Modal>
    )
}